export const ONBOARDING = '/user-onboarding';
export const CREATE_ORGANIZATION = '/create-org';
export const CREATE_PROJECT = '/new-project';

export const AUTH = '/auth';
export const AUTH_CALLBACK = '/auth-callback';
export const INVITE_SIGNUP = '/invite-signup';

export const DASHBOARD = '/dashboard';
export const STORAGE = '/files';
export const BUCKET = '/bucket';
export const BUCKETS = '/buckets';
export const DISKS = '/disks';
export const IMAGES = '/images';
export const SECRETS = '/secrets';
export const JOB = '/job-details';
export const JOBS = '/jobs';
export const NEW_JOB = '/new-job';
export const BAKE = '/bake';
export const FLOW = '/flow';
export const FLOWS = '/flows';
export const ORGANIZATIONS_INVITES = '/invites';

export const CLUSTER_SETTINGS = '/cluster-settings';
export const CLUSTER_SETTINGS_GENERAL = `${CLUSTER_SETTINGS}/general`;
export const CLUSTER_SETTINGS_USERS = `${CLUSTER_SETTINGS}/users`;
export const CLUSTER_SETTINGS_REPORTS = `${CLUSTER_SETTINGS}/reports`;

export const ORGANIZATION_SETTINGS = '/org-settings';
export const ORGANIZATION_SETTINGS_GENERAL = `${ORGANIZATION_SETTINGS}/general`;
export const ORGANIZATION_SETTINGS_USERS = `${ORGANIZATION_SETTINGS}/users`;
export const ORGANIZATION_SETTINGS_REPORTS = `${ORGANIZATION_SETTINGS}/reports`;

export const ADMIN_SECTION = '/admin';
export const ADMIN_SECTION_USERS = `${ADMIN_SECTION}/users`;
export const ADMIN_SECTION_CLUSTERS = `${ADMIN_SECTION}/clusters`;
export const ADMIN_SECTION_ORGANIZATIONS = `${ADMIN_SECTION}/organizations`;

export const APPS = '/apps';
export const APPS_INSTANCE = '/app-details';
export const APPS_INSTALLED = `${APPS}/installed`;
export const APPS_LEGACY = `${APPS}/legacy`;
export const APPS_DEV_SCHEMA = `${APPS}/dev-schema`;

export const PROJECT_SETTINGS = '/project-settings';
export const PROJECT_SETTINGS_GENERAL = `${PROJECT_SETTINGS}/general`;
export const PROJECT_SETTINGS_USERS = `${PROJECT_SETTINGS}/users`;
export const PROJECT_SETTINGS_REPORTS = `${PROJECT_SETTINGS}/reports`;

export const BILLING = '/org-billing';
export const BILLING_USAGE = `${BILLING}/usage`;
export const BILLING_CREDITS = `${BILLING}/credits`;

export const HOME = APPS;

export const DOCS = 'https://docs.apolo.us';
export const TERMS_OF_USE = 'https://apolo.us/terms-of-use';
